import { HttpClient } from '@angular/common/http'
import { lastValueFrom } from 'rxjs'
import { osmAutocompleteApiKey, verifyUrl } from './street-autocomplete.config'

export interface VerifyAddressInput {
  street: string
  housenumber: string
  postcode: string
  city: string
}

export interface VerifiedAddress {
  street: string
  housenumber: string
  postcode: string
  city: string
  country: string
  lat: number
  lon: number
}

export interface VerifyAddressFieldMismatch {
  input: string
  actual: string
}

export type VerifyAddressMismatchField = 'street' | 'housenumber' | 'postcode' | 'city'

export type VerifyAddressMismatches = Partial<Record<VerifyAddressMismatchField, VerifyAddressFieldMismatch>>

export interface VerifyAddressFound {
  found: true
  input: VerifyAddressInput
  match: VerifiedAddress
}

export interface VerifyAddressNotFound {
  found: false
  input: VerifyAddressInput
  best_match: VerifiedAddress | null
  mismatches: VerifyAddressMismatches | null
}

export type VerifyAddressResponse = VerifyAddressFound | VerifyAddressNotFound

export function verifyAddress(http: HttpClient, params: VerifyAddressInput): Promise<VerifyAddressResponse> {
  return lastValueFrom(
    http.get<VerifyAddressResponse>(verifyUrl, {
      params: { ...params },
      headers: { 'x-api-key': osmAutocompleteApiKey },
    }),
  )
}
